import { useLocation } from 'react-router-dom';

/**
 * Routes where the footer is suppressed (ARC-147). The footer renders on the
 * standard pages (lobby, market/event, portfolio, account, …) but NOT on the
 * deposit/withdraw funnel (`/wallet`) or the dev surfaces. The full-screen
 * modal flows (KYC, buy-in, auth, terms) are portal overlays rather than
 * routes, so they sit above the footer and need no entry here.
 */
const HIDDEN_PREFIXES = ['/wallet', '/dev'];

export function useFooterVisible(): boolean {
  const { pathname } = useLocation();
  return !HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
